import { useState } from "react";
import { LogOut, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "./ui/dialog";
import { api, errMsg } from "../lib/api";

const PasswordDialog = ({ open, onOpenChange }) => {
  const [f, setF] = useState({ current_password: "", new_password: "", new_password_repeat: "" });
  const field = (k, label, id) => (
    <label className="grid gap-1 text-sm font-medium text-slate-700">{label}
      <Input type="password" value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="h-10" data-testid={id} />
    </label>
  );
  const save = async () => {
    try { const r = await api.changePassword(f); toast.success(r.message); onOpenChange(false); setF({ current_password: "", new_password: "", new_password_repeat: "" }); }
    catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="change-password-dialog">
        <DialogHeader><DialogTitle>Passwort ändern</DialogTitle></DialogHeader>
        <div className="grid gap-3">
          {field("current_password", "Aktuelles Passwort", "pw-current-input")}
          {field("new_password", "Neues Passwort (mind. 10 Zeichen)", "pw-new-input")}
          {field("new_password_repeat", "Neues Passwort wiederholen", "pw-repeat-input")}
        </div>
        <DialogFooter><Button onClick={save} className="bg-slate-900 hover:bg-slate-800" data-testid="pw-save-btn">Speichern</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export const AccountMenu = ({ user, onLogout }) => {
  const [open, setOpen] = useState(false);
  const logout = async () => { await api.logout().catch(() => {}); onLogout(); };
  return (
    <div className="grid gap-1 border-t border-slate-200 pt-3" data-testid="account-menu">
      <div className="truncate px-3 text-xs text-slate-500" data-testid="account-email">{user?.email}</div>
      <div className="flex gap-1">
        <Button variant="ghost" size="sm" onClick={() => setOpen(true)} className="flex-1 justify-start gap-1.5" data-testid="change-password-btn"><KeyRound className="h-4 w-4" />Passwort ändern</Button>
        <Button variant="ghost" size="sm" onClick={logout} className="gap-1.5 text-red-700 hover:bg-red-50" data-testid="logout-btn"><LogOut className="h-4 w-4" />Abmelden</Button>
      </div>
      <PasswordDialog open={open} onOpenChange={setOpen} />
    </div>
  );
};
